<script>
import appConfig from '@/app.config'
import PageHeader from '@/components/page-header'
import Layout from '@/router/layouts/main'
import Multiselect from 'vue-multiselect'
import Swal from 'sweetalert2'

/**
 * Starter component
 */
export default {
  page: {
    title: 'Setting',
    meta: [{ name: 'description', content: appConfig.description }],
  },
  components: {
    Layout,
    PageHeader,
    Multiselect,
  },
  data() {
    return {
      filter: {
        scheduleParam: 'Bulanan',
        scheduleValue: null,
        isActive: false,
      },
      cekNonaktifFleetLicense: {
        all: true,
        stnk: true,
        bpkb: true,
        inactive: 'Nonaktifkan',
      },
      cekNonaktifDriverLicense: {
        all: true,
        simA: true,
        simB: true,
        simC: true,
        inactive: 'Nonaktifkan',
      },
      groupEmail: null,
      userEmail: null,
    }
  },
  computed: {
    title() {
      return 'Pengingat Lisensi'
    },

    items() {
      return [
        {
          text: this.$t('setting.list.userSetting.setting'),
        },
        {
          text: this.$t('setting.list.userSetting.pengaturanPengguna'),
        },
      ]
    },
  },

  methods: {
    toSend() {
      Swal.fire({
        title: this.$t('license.text.sendSuccess'),
        text: this.$t('license.text.reminderSent'),
        icon: 'success',
        confirmButtonColor: '#0d4491',
        confirmButtonText: 'OK',
      }).then((result) => {
        if (result.value) {
          this.$router.push('/license/licensesetting')
        }
      })
    },

    checkAllFleetLicense() {
      this.cekNonaktifFleetLicense.all = !this.cekNonaktifFleetLicense.all
      let obj = { ...this.cekNonaktifFleetLicense }
      let param = this.cekNonaktifFleetLicense.all
      Object.keys(obj).forEach(function (key) {
        if (key !== 'all') {
          obj[key] = param
        }
      })
      this.cekNonaktifFleetLicense = obj
    },

    checkAllDriverLicense() {
      this.cekNonaktifDriverLicense.all = !this.cekNonaktifDriverLicense.all
      let obj = { ...this.cekNonaktifDriverLicense }
      let param = this.cekNonaktifDriverLicense.all
      Object.keys(obj).forEach(function (key) {
        if (key !== 'all') {
          obj[key] = param
        }
      })
      this.cekNonaktifDriverLicense = obj
    },
  },
}
</script>

<style>
.cl-1 {
  color: #0b3a7b;
}
</style>

<template>
  <Layout>
    <PageHeader :title="title" />

    <p class="mb-4">{{ $t('license.text.manageFrequent') }}</p>

    <div class="clearfix mc-btn-group__list">
      <div class="float-end">
        <b-button
          variant="outline-primary"
          @click="$router.push({ name: 'List License' })"
          class="mx-2"
        >
          {{ $t('global.back') }}
        </b-button>

        <b-button variant="primary" type="button">
          <i class="fas fa-save"></i> {{ this.$t('global.save') }}
        </b-button>
      </div>
    </div>

    <div class="row">
      <div class="col-md-3 mt-4">
        <div class="mb-3 position-relative">
          <label for="validationTooltipUsername">{{ $t('report.object.schedule') }}</label>
          <div class="input-group">
            <div class="input-group-prepend">
              <b-form-select
                v-model="filter.scheduleParam"
                class="form-select input-group-text"
                id="formrow-inputState"
                :options="['Bulanan', 'Mingguan', 'Tanggal']"
                type="text"
              ></b-form-select>
            </div>
            <b-form-select
              v-if="filter.scheduleParam === 'Bulanan'"
              class="form-select"
              id="formrow-inputState"
              placeholder="Awal Bulan"
              :options="['Awal Bulan', 'Akhir Bulan']"
              type="text"
              v-model="filter.scheduleValue"
            ></b-form-select>
            <b-form-select
              v-else-if="filter.scheduleParam === 'Mingguan'"
              class="form-select"
              id="formrow-inputState"
              :options="['Senin', 'Selasa', 'Rabu', 'Kamis', 'Jumat', 'Sabtu', 'Minggu']"
              type="text"
              v-model="filter.scheduleValue"
            ></b-form-select>
            <b-form-select
              v-else-if="filter.scheduleParam === 'Tanggal'"
              class="form-select"
              id="formrow-inputState"
              :options="['1', '2', '3', '4', '5']"
              type="text"
              v-model="filter.scheduleValue"
            ></b-form-select>
          </div>
        </div>
      </div>
      <div class="col-md-3 mt-4">
        <b-form-group
          class="mb-3 form-label"
          id="input-group-1"
          :label="$t('global.field.groupEmail')"
          label-for="formrow-inputState"
        >
          <multiselect
            v-model="groupEmail"
            :options="[
              'IT Staff',
              'Sales & Marketing',
              'Admin Operational',
              'Branding',
              'Logistic',
              'Admin IT',
              'Operational Staff',
            ]"
            :multiple="true"
            :placeholder="$t('global.field.groupEmail')"
          ></multiselect>
        </b-form-group>
      </div>
      <div class="col-md-3 mt-4">
        <b-form-group
          class="mb-3 form-label"
          id="input-group-1"
          :label="$t('global.field.userEmail')"
          label-for="formrow-inputState"
        >
          <multiselect
            v-model="userEmail"
            :options="[
              'kang.tri@mail.com',
              'kang.hadi@mail.com',
              'kang.octa@mail.com',
              'kang.prakoso@mail.com',
            ]"
            :multiple="true"
            :placeholder="$t('global.field.userEmail')"
          ></multiselect>
        </b-form-group>
      </div>
      <div class="col-md-3 mb-4 align-self-end">
        <div class="float-end">
          <b-button variant="outline-primary" @click="toSend" class="mx-2">
            <i class="bx bx-navigation"></i> {{ $t('global.action.sendNow') }}
          </b-button>
        </div>
      </div>
    </div>

    <div class="card">
      <div class="card-body">
        <div class="row">
          <div class="col-md-6 mt-4">
            <h5>
              <b>{{ $t('license.object.vehicleLicense') }}</b>
            </h5>
          </div>
          <div class="col-md-6 align-self-end">
            <div class="float-end mt-4">
              <h6
                class="cl-1"
                @click="checkAllFleetLicense"
                v-if="!cekNonaktifFleetLicense.all"
                style="cursor: pointer"
              >
                {{ $t('global.action.activate') }}
              </h6>
              <h6 class="cl-1" @click="checkAllFleetLicense" v-else style="cursor: pointer">
                {{ $t('global.action.nonactivate') }}
              </h6>
            </div>
          </div>
        </div>

        <div class="border p-3 rounded mt-4">
          <div class="row">
            <div class="col-md-6 mt-3">
              <h6>STNK</h6>
            </div>
            <div class="col-md-6 align-self-end">
              <div class="float-end mt-3">
                <div class="form-check form-switch form-switch-md mb-3">
                  <input
                    v-model="cekNonaktifFleetLicense.stnk"
                    class="form-check-input"
                    type="checkbox"
                    id="SwitchCheckSizemd"
                  />
                </div>
              </div>
            </div>
          </div>

          <div class="row">
            <div class="col-md-6 mt-3">
              <h6>BPKB</h6>
            </div>
            <div class="col-md-6 align-self-end">
              <div class="float-end mt-3">
                <div class="form-check form-switch form-switch-md mb-3">
                  <input
                    v-model="cekNonaktifFleetLicense.bpkb"
                    class="form-check-input"
                    type="checkbox"
                    id="SwitchCheckSizemd"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="row">
          <div class="col-md-6 mt-4">
            <h5>
              <b>{{ $t('license.object.driverLicense') }}</b>
            </h5>
          </div>
          <div class="col-md-6 align-self-end">
            <div class="float-end mt-4">
              <h6
                class="cl-1"
                @click="checkAllDriverLicense"
                v-if="!cekNonaktifDriverLicense.all"
                style="cursor: pointer"
              >
                {{ $t('global.action.activate') }}
              </h6>
              <h6 class="cl-1" @click="checkAllDriverLicense" v-else style="cursor: pointer">
                {{ $t('global.action.nonactivate') }}
              </h6>
            </div>
          </div>
        </div>

        <div class="border p-3 rounded mt-4">
          <div class="row">
            <div class="col-md-6 mt-3">
              <h6>SIM A</h6>
            </div>
            <div class="col-md-6 align-self-end">
              <div class="float-end mt-3">
                <div class="form-check form-switch form-switch-md mb-3">
                  <input
                    v-model="cekNonaktifDriverLicense.simA"
                    class="form-check-input"
                    type="checkbox"
                    id="SwitchCheckSizemd"
                  />
                </div>
              </div>
            </div>
          </div>

          <div class="row">
            <div class="col-md-6 mt-3">
              <h6>SIM B</h6>
            </div>
            <div class="col-md-6 align-self-end">
              <div class="float-end mt-3">
                <div class="form-check form-switch form-switch-md mb-3">
                  <input
                    v-model="cekNonaktifDriverLicense.simB"
                    class="form-check-input"
                    type="checkbox"
                    id="SwitchCheckSizemd"
                  />
                </div>
              </div>
            </div>
          </div>

          <div class="row">
            <div class="col-md-6 mt-3">
              <h6>SIM C</h6>
            </div>
            <div class="col-md-6 align-self-end">
              <div class="float-end mt-3">
                <div class="form-check form-switch form-switch-md mb-3">
                  <input
                    v-model="cekNonaktifDriverLicense.simC"
                    class="form-check-input"
                    type="checkbox"
                    id="SwitchCheckSizemd"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </Layout>
</template>
